module.exports = __webpack_public_path__ + "static/media/primary_disabled.67de9563.svg";